(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MultipleCommandsArgumentsController', MultipleCommandsArgumentsController);

    MultipleCommandsArgumentsController.$inject = ['$uibModal', '$scope', '$stateParams', 'TabActions', 'TabObjects', 'TabActionsQueue', 'AlertService', 'ParseLinks', 'Macro', 'Queue', '$rootScope', 'CommandManifest', '$filter'];

    function MultipleCommandsArgumentsController($uibModal, $scope, $stateParams, TabActions, TabObjects, TabActionsQueue, AlertService, ParseLinks, Macro, Queue, $rootScope, CommandManifest, $filter) {
        var vm = this;
        var commandStash = {};
        vm.tabCommands = [];
        vm.currentPage = 0;
        vm.tabActionsQueues = [];
        vm.actionDeviceReleaseMap = [];
        vm.datepickerOptions = {
            minDate: new Date()
        };
        vm.objectList = $stateParams.objects;
        vm.commandList = $stateParams.commands;
        vm.macro = $stateParams.macros;
        vm.licence = $rootScope.licence;
        vm.isGreengrassObject = false;

        vm.loadAll = function () {
            vm.tabObjectsActions = [];

            vm.isGreengrassObject = vm.objectList.some(function(obj) {
                return obj.objectType && obj.objectType.greengrassType === true;
            });

            if (vm.isGreengrassObject) {
                console.log('=== GREENGRASS OBJECTS DETECTED ===');
                console.log('Selected objects:', vm.objectList.length);

                // Recupera l'ObjectType dal primo oggetto
                var objectTypeId = vm.objectList[0].objectType.id;
                var fleetId = vm.objectList[0].fleet ? vm.objectList[0].fleet.id : null;

                // Cerca il manifest template salvato
                var cacheKey = 'manifestTemplate_' + objectTypeId + '_' + fleetId;
                var cachedManifestStr = localStorage.getItem(cacheKey);

                if (cachedManifestStr) {
                    try {
                        var cachedData = JSON.parse(cachedManifestStr);

                        console.log('✓ Using cached manifest template');
                        console.log('  Loaded from object:', cachedData.sourceObject);
                        console.log('  Object status:', cachedData.objectStatus);
                        console.log('  Cached at:', cachedData.timestamp);
                        console.log('  Will be applied to', vm.objectList.length, 'selected objects');

                        // Usa il manifest cached
                        var manifestData = cachedData.manifest;

                        // Trasforma il manifest in tabActions
                        var transformedData = transformManifestToTabActions(manifestData, vm.objectList[0]);

                        if (vm.macro && vm.macro.length > 0) {
                            loadGreengrassMacroCommands(manifestData, vm.objectList[0], transformedData);
                        } else {
                            onSuccess(transformedData);
                        }

                    } catch (e) {
                        console.error('Error parsing cached manifest:', e);
                        AlertService.error('Error loading cached manifest. Please go back and reload commands.');
                    }

                } else {
                    console.error('No cached manifest template found!');
                    console.error('Cache key:', cacheKey);
                    AlertService.error('Manifest template not found. Please go back and reload commands.');
                }
            } else {
                if(vm.commandList.length > 0){
                    TabActions.commandsByObjects({}, {objects: vm.objectList , commands: vm.commandList}, onSuccess, onError);
                }
            }

            function loadGreengrassMacroCommands(manifestData, greengrassObject, existingTransformedData) {
                console.log('%c=== LOADING GREENGRASS MACRO COMMANDS ===', 'color: #E91E63; font-weight: bold;');
                console.log('Number of macros to load:', vm.macro.length);
                console.log('Macros:', vm.macro);

                if (!vm.macro || vm.macro.length === 0) {
                    console.warn('No macros to load, calling onSuccess with existing data');
                    onSuccess(existingTransformedData);
                    return;
                }

                var macroCommandsToLoad = [];
                var macroCommandsLoaded = 0;

                vm.macro.forEach(function(macro, macroIndex) {
                    console.log('%c[Macro ' + (macroIndex + 1) + '/' + vm.macro.length + '] Loading commands for macro:', 'color: #E91E63; font-weight: bold;', macro.alias, 'ID:', macro.id);

                    Macro.getMacroDetails({macroId: macro.id}, function(queueCommands) {
                        console.log('%c[Macro ' + macro.alias + '] QueueCommands received:', 'color: #4CAF50;', queueCommands.length, 'commands');
                        console.log('QueueCommands:', queueCommands);

                        queueCommands.forEach(function(qc, qcIndex) {
                            console.log('  [Command ' + (qcIndex + 1) + '] Name:', qc.commandName, 'Arguments:', qc.arguments);

                            var parsedArguments = {};
                            try {
                                parsedArguments = qc.arguments ? JSON.parse(qc.arguments) : {};
                                console.log('  Parsed arguments:', parsedArguments);
                            } catch (e) {
                                console.error('  Failed to parse arguments:', e);
                            }

                            macroCommandsToLoad.push({
                                commandName: qc.commandName,
                                arguments: parsedArguments,
                                macroAlias: macro.alias,
                                order: qc.order
                            });
                        });

                        macroCommandsLoaded++;
                        console.log('%cMacros loaded so far: ' + macroCommandsLoaded + '/' + vm.macro.length, 'color: #2196F3;');

                        if (macroCommandsLoaded === vm.macro.length) {
                            console.log('%c=== ALL MACROS LOADED ===', 'color: #4CAF50; font-weight: bold;');
                            console.log('Total macro commands to transform:', macroCommandsToLoad.length);
                            console.log('Macro commands:', macroCommandsToLoad);

                            var allTransformedData = transformMacroCommandsFromManifest(
                                manifestData,
                                greengrassObject,
                                macroCommandsToLoad,
                                existingTransformedData
                            );

                            console.log('Calling onSuccess with', allTransformedData.length, 'total commands');
                            onSuccess(allTransformedData);
                        }
                    }, function(error) {
                        console.error('%c[Macro ' + macro.alias + '] ERROR loading macro details:', 'color: #F44336; font-weight: bold;', error);
                        console.error('Error status:', error.status);
                        console.error('Error data:', error.data);

                        macroCommandsLoaded++;
                        console.log('Macros loaded (with error) so far: ' + macroCommandsLoaded + '/' + vm.macro.length);

                        if (macroCommandsLoaded === vm.macro.length) {
                            console.warn('All macros processed (some with errors), calling onSuccess');
                            onSuccess(existingTransformedData);
                        }
                    });
                });
            }

            function transformMacroCommandsFromManifest(manifestData, obj, macroCommands, existingData) {
                console.log('%c=== TRANSFORMING MACRO COMMANDS FROM MANIFEST ===', 'color: #9C27B0; font-weight: bold;');

                var result = existingData || [];

                if (!manifestData || !manifestData.manifest) {
                    console.warn('Invalid manifest data');
                    return result;
                }

                macroCommands.forEach(function(macroCmd) {
                    console.log('Processing macro command:', macroCmd.commandName, 'from macro:', macroCmd.macroAlias);

                    var commandFound = false;

                    Object.keys(manifestData.manifest).forEach(function(componentName) {
                        var commands = manifestData.manifest[componentName];

                        commands.forEach(function(command) {
                            if (command.command_name === macroCmd.commandName) {
                                console.log('Found matching command in manifest:', command.command_name);
                                commandFound = true;

                                var argumentsSchema = null;
                                if (command.arguments && (Array.isArray(command.arguments) && command.arguments.length > 0 ||
                                    (typeof command.arguments === 'object' && Object.keys(command.arguments).length > 0))) {
                                    argumentsSchema = convertGreengrassArgumentsToJsonSchema(command.arguments);
                                }

                                var tabAction = {
                                    id: 2000 + result.length,
                                    actionCommand: command.command_name,
                                    description: command.description || command.command_name,
                                    permissionLevel: command.permission_level || 1,
                                    weight: command.weight || 1,
                                    argumentsSchema: argumentsSchema ? angular.toJson(argumentsSchema) : null,
                                    isMacroCommand: true,
                                    macroAlias: macroCmd.macroAlias,
                                    macroArguments: macroCmd.arguments,
                                    macroOrder: macroCmd.order,
                                    deviceReleases: {
                                        id: 600 + result.length,
                                        deviceReleaseName: componentName,
                                        deviceReleaseDescription: 'Greengrass component: ' + componentName,
                                        isActive: true,
                                        deviceReleaseVersion: '',
                                        device: {
                                            id: 300 + result.length,
                                            deviceName: componentName.split('.').pop(),
                                            deviceDescription: 'Greengrass device for ' + componentName,
                                            isActive: true,
                                            isVisibile: true,
                                            deviceType: {
                                                id: 100,
                                                deviceTypeName: 'Greengrass Component Type',
                                                deviceTypeDescription: 'AWS IoT Greengrass Component',
                                                isActive: true,
                                                isVisibile: true,
                                                entityId: 100
                                            },
                                            entityId: 300 + result.length
                                        },
                                        entityId: 600 + result.length
                                    }
                                };

                                console.log('Transformed macro command:', tabAction);
                                result.push(tabAction);
                            }
                        });
                    });

                    if (!commandFound) {
                        console.warn('Command not found in manifest:', macroCmd.commandName);
                    }
                });

                console.log('Total commands after macro transformation:', result.length);
                return result;
            }

            function transformManifestToTabActions(manifestData, obj) {
                var result = [];

                if (!manifestData || !manifestData.manifest) {
                    console.warn('Invalid manifest data:', manifestData);
                    return result;
                }

                console.log('%c=== GREENGRASS MANIFEST TRANSFORMATION ===', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
                console.log('Original Greengrass manifest data:', manifestData);

                var selectedCommandNames = new Set();
                vm.commandList.forEach(function(cmd) {
                    selectedCommandNames.add(cmd.actionCommand);
                });

                console.log('Selected command names:', Array.from(selectedCommandNames));

                Object.keys(manifestData.manifest).forEach(function(componentName) {
                    var commands = manifestData.manifest[componentName];

                    console.log('%cProcessing component: ' + componentName, 'color: #2196F3; font-weight: bold;');
                    console.log('Commands in component:', commands);

                    commands.forEach(function(command, index) {
                        if (!selectedCommandNames.has(command.command_name)) {
                            console.log('%cSkipping command: ' + command.command_name + ' (not selected)', 'color: #FF5722;');
                            return;
                        }

                        console.log('%cIncluding command: ' + command.command_name + ' (selected)', 'color: #4CAF50;');

                        var argumentsSchema = null;

                        if (command.arguments && (Array.isArray(command.arguments) && command.arguments.length > 0 ||
                            (typeof command.arguments === 'object' && Object.keys(command.arguments).length > 0))) {

                            argumentsSchema = convertGreengrassArgumentsToJsonSchema(command.arguments);
                        }

                        var tabAction = {
                            id: 1000 + result.length,
                            actionCommand: command.command_name,
                            description: command.description || command.command_name,
                            permissionLevel: command.permission_level || 1,
                            weight: command.weight || 1,
                            argumentsSchema: argumentsSchema ? angular.toJson(argumentsSchema) : null,
                            deviceReleases: {
                                id: 500 + result.length,
                                deviceReleaseName: componentName,
                                deviceReleaseDescription: 'Greengrass component: ' + componentName,
                                isActive: true,
                                deviceReleaseVersion: '',
                                device: {
                                    id: 200 + result.length,
                                    deviceName: componentName.split('.').pop(),
                                    deviceDescription: 'Greengrass device for ' + componentName,
                                    isActive: true,
                                    isVisibile: true,
                                    deviceType: {
                                        id: 100,
                                        deviceTypeName: 'Greengrass Component Type',
                                        deviceTypeDescription: 'AWS IoT Greengrass Component',
                                        isActive: true,
                                        isVisibile: true,
                                        entityId: 100
                                    },
                                    entityId: 200 + result.length
                                },
                                entityId: 500 + result.length
                            }
                        };

                        console.log('%cCommand #' + (result.length + 1) + ': ' + command.command_name, 'color: #FF9800;');
                        console.log('  - Component Name (deviceReleaseName):', componentName);
                        console.log('  - Arguments Schema:', argumentsSchema);
                        console.log('  - Transformed TabAction:', tabAction);

                        result.push(tabAction);
                    });
                });

                console.log('%c=== TRANSFORMATION COMPLETE ===', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
                console.log('Total commands transformed:', result.length);
                console.log('Final result:', result);

                return result;
            }

            // Convert Greengrass arguments format to JSON Schema format
            function convertGreengrassArgumentsToJsonSchema(greengrassArgs) {
                var properties = {};
                var required = [];
                var order = 1;

                console.log('  Converting arguments:', greengrassArgs);

                var argsArray = Array.isArray(greengrassArgs) ? greengrassArgs :
                    (typeof greengrassArgs === 'object' ? [] : []);

                if (argsArray.length === 0 && typeof greengrassArgs === 'object' && !Array.isArray(greengrassArgs)) {
                    console.log('  No arguments to convert');
                    return null;
                }

                argsArray.forEach(function(arg) {
                    var key = arg.key;
                    var props = arg.props || {};

                    var property = {
                        description: props.description || props.label || '',
                        title: key,
                        type: mapGreengrassTypeToJsonSchemaType(arg.type)
                    };

                    if (arg.defaultValue !== undefined && arg.defaultValue !== null) {
                        property.default = arg.defaultValue;
                    }

                    property.order = order++;

                    if (arg.type === 'timepicker') {
                        property.format = 'time';
                    }

                    if (arg.type === 'slider') {
                        property.component = 'range';
                        property.options = {
                            step: 1,
                            floor: props.min !== undefined ? props.min : 0,
                            ceil: props.max !== undefined ? props.max : 100
                        };
                        property.minimum = props.min;
                        property.maximum = props.max;
                        if (props.thumbLabel !== undefined) {
                            property.thumbLabel = props.thumbLabel;
                        }
                    }

                    if (arg.type === 'select' && props.options && props.options.length > 0) {
                        property.titleMap = props.options.map(function(option) {
                            return {
                                name: option.label,
                                value: String(option.value)
                            };
                        });

                        property.enum = props.options.map(function(option) {
                            return String(option.value);
                        });

                        if (property.default !== undefined && property.default !== null) {
                            property.default = String(property.default);
                        }
                    }

                    if (arg.type === 'slider') {
                        property.component = 'range';
                    }

                    if (props.required) {
                        required.push(key);
                    }

                    properties[key] = property;

                    console.log('  - Property "' + key + '":', property);
                });

                var schema = {
                    metricReference: {},
                    type: 'object',
                    properties: properties
                };

                if (required.length > 0) {
                    schema.required = required;
                }

                console.log('  Final schema:', schema);

                return schema;
            }

            function mapGreengrassTypeToJsonSchemaType(greengrassType) {
                switch(greengrassType) {
                    case 'slider':
                        return 'number';
                    case 'toggle':
                        return 'boolean';
                    case 'text':
                    case 'input':
                    case 'timepicker':
                        return 'string';
                    case 'select':
                        return 'string';
                    default:
                        return 'string';
                }
            }

            function onSuccess(data) {
                console.log('%c=== FORM CREATION FROM DATA ===', 'color: #9C27B0; font-weight: bold; font-size: 14px;');
                console.log('Data received in onSuccess:', data);

                vm.formSchemas = {
                    forms: [],
                    buttons: []
                };

                // Aggiungi una struttura per memorizzare i comandi delle macro raggruppati
                vm.macroCommands = {};

                for (var i = 0; i < data.length; i++) {
                    $scope.formSchema = [];
                    vm.tabObjectsActions.push(data[i]);

                    if(!vm.actionDeviceReleaseMap[data[i].id])
                        vm.actionDeviceReleaseMap[data[i].id] = [];
                    vm.actionDeviceReleaseMap[data[i].id].push({
                        idAction: data[i].id,
                        deviceReleases: {
                            deviceReleaseName: data[i].deviceReleases.deviceReleaseName
                        }
                    });

                    console.log('%cProcessing command: ' + data[i].actionCommand, 'color: #9C27B0; font-weight: bold;');
                    console.log('  Device Release Name:', data[i].deviceReleases.deviceReleaseName);
                    console.log('  Is Macro Command:', data[i].isMacroCommand);

                    // Se è un comando di una macro, memorizzalo separatamente
                    if (data[i].isMacroCommand) {
                        if (!vm.macroCommands[data[i].macroAlias]) {
                            vm.macroCommands[data[i].macroAlias] = [];
                        }
                        vm.macroCommands[data[i].macroAlias].push({
                            actionId: data[i].id,
                            actionCommand: data[i].actionCommand,
                            deviceReleases: data[i].deviceReleases,
                            arguments: data[i].macroArguments,
                            order: data[i].macroOrder
                        });
                        console.log('  Added to macro commands for:', data[i].macroAlias);
                        continue; // Non aggiungere ai form/buttons
                    }

                    if (data[i].argumentsSchema != null) {
                        var jArg = angular.fromJson(data[i].argumentsSchema);
                        console.log('  Parsed argumentsSchema:', jArg);

                        var first = Object.keys(jArg.properties)[0];
                        if (jArg.properties[first].hasOwnProperty('order')) {
                            console.log('  Using ORDER-based sorting');
                            var orderProps = [];
                            orderProps.length = Object.keys(jArg.properties).length;
                            Object.keys(jArg.properties).forEach(function (val) {
                                var entry = vm.getEntry(jArg, val, null);
                                console.log('    Entry for "' + val + '":', entry);
                                orderProps.splice(Number(jArg.properties[val].order) - 1, 1, entry);
                            });
                            orderProps.forEach(function (val) {
                                $scope.formSchema.push(val);
                            });
                        } else {
                            console.log('  Using NATURAL ordering');
                            Object.keys(jArg.properties).forEach(function (val) {
                                var entry = vm.getEntry(jArg, val, null);
                                console.log('    Entry for "' + val + '":', entry);
                                $scope.formSchema.push(entry);
                            });
                        }

                        var formToAdd = {
                            command: data[i].actionCommand,
                            form: $scope.formSchema,
                            schema: jArg,
                            deviceReleases: data[i].deviceReleases,
                            actionId: data[i].id,
                            weight: data[i].weight
                        };

                        // Initialize default values
                        Object.keys(jArg.properties).forEach(function(propKey) {
                            if (jArg.properties[propKey].hasOwnProperty('default')) {
                                formToAdd[propKey] = jArg.properties[propKey].default;
                            }
                        });

                        console.log('  Form to add:', formToAdd);
                        vm.formSchemas.forms.push(formToAdd);
                    } else {
                        console.log('  No arguments - adding as BUTTON');
                        vm.formSchemas.buttons.push({
                            command: data[i].actionCommand,
                            deviceReleases: data[i].deviceReleases,
                            actionId: data[i].id
                        });
                    }
                }

                console.log('%cFinal formSchemas:', 'color: #9C27B0; font-weight: bold;');
                console.log('  Forms:', vm.formSchemas.forms);
                console.log('  Buttons:', vm.formSchemas.buttons);
                console.log('  Macro Commands:', vm.macroCommands);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.getEntry = function(jArg, val, arrayName) {
            var entry = {};
            if(arrayName != null)
                entry.key = arrayName + "[]." + val;
            else
                entry.key = val;
            if (jArg.properties[val].hasOwnProperty('titleMap')) {
                entry.titleMap = jArg.properties[val].titleMap;
                entry.type = 'select';
                entry.title = jArg.properties[val].title || val;
                entry.description = jArg.properties[val].description || '';
                entry.schema = jArg.properties[val];
                if (jArg.required && jArg.required.indexOf(val) !== -1) {
                    entry.required = true;
                }
            }
            if (jArg.properties[val].type === 'string' && !jArg.properties[val].hasOwnProperty('titleMap')) {
                if (jArg.properties[val].format === 'time') {
                    entry.type = 'timepicker';
                } else {
                    entry.type = 'text';
                }
                entry.title = jArg.properties[val].title || val;
                entry.description = jArg.properties[val].description || '';
                entry.schema = jArg.properties[val];
                if (jArg.required && jArg.required.indexOf(val) !== -1) {
                    entry.required = true;
                }
            }
            if (jArg.properties[val].hasOwnProperty('component') && !jArg.properties[val].hasOwnProperty('titleMap'))
                entry.type = jArg.properties[val].component;
            if (jArg.properties[val].hasOwnProperty('options'))
                entry.options = jArg.properties[val].options;
            if (jArg.properties[val].hasOwnProperty('style'))
                entry.style = jArg.properties[val].style;
            if (jArg.properties[val].hasOwnProperty('maxDate'))
                entry.maxDate = jArg.properties[val].maxDate;
            if (jArg.properties[val].hasOwnProperty('minDate'))
                entry.minDate = jArg.properties[val].minDate;
            if (jArg.properties[val].hasOwnProperty('format') && jArg.properties[val].format == 'time') {
                if (jArg.properties[val].default && typeof jArg.properties[val].default === 'string') {
                    var timeParts = jArg.properties[val].default.split(':');
                    var timeDate = new Date();
                    timeDate.setHours(parseInt(timeParts[0]) || 0);
                    timeDate.setMinutes(parseInt(timeParts[1]) || 0);
                    timeDate.setSeconds(0);
                    timeDate.setMilliseconds(0);
                    jArg.properties[val].default = timeDate;
                }
            }
            if (jArg.properties[val].hasOwnProperty('default')) {
                jArg.properties[val].defaultRestore = angular.copy(jArg.properties[val].default);
            }
            if (jArg.properties[val].hasOwnProperty('items')) {
                entry.items = [];
                var first = Object.keys(jArg.properties[val].items.properties)[0];
                if (jArg.properties[val].items.properties[first].hasOwnProperty('order')) {
                    var orderProps = [];
                    orderProps.length = Object.keys(jArg.properties[val].items.properties).length;
                    Object.keys(jArg.properties[val].items.properties).forEach(function (item) {
                        orderProps.splice(Number(jArg.properties[val].items.properties[item].order) - 1, 1, vm.getEntry(jArg.properties[val].items, item, val));
                    });
                    orderProps.forEach(function (val) {
                        entry.items.push(val);
                    });
                } else {
                    Object.keys(jArg.properties[val].items.properties).forEach(function (item) {
                        entry.items.push(vm.getEntry(jArg.properties[val].items, item, val));
                    });
                }
            }
            return entry;
        };

        vm.checkSave = function(){

            var objects = [];
            for(var i = 0; i < vm.objectList.length; i++){
                objects.push(vm.objectList[i].objectUniqueCode);
            }
            localStorage.setItem("check-multiple-save", JSON.stringify(objects));
            $uibModal.open({
                templateUrl: 'app/management/multiple-commands/check-save.html',
                controller: 'CheckSaveController',
                controllerAs: 'vm',
                size: 'md'
            }).result.then(function () {
                save();
            });
        };

        function save() {
            $scope.$broadcast('schemaFormValidate');
            if($('form.ng-invalid').length == 0 && $('form.ng-invalid-add').length == 0) {
                vm.isSaving = true;

                console.log('%c=== SAVING COMMANDS ===', 'color: #FF5722; font-weight: bold;');
                console.log('Is Greengrass Object:', vm.isGreengrassObject);
                console.log('Form Schemas:', vm.formSchemas);
                console.log('Macro Commands:', vm.macroCommands);

                if(vm.commandList.length > 0){
                    vm.formSchemas.buttons.forEach(function (value) {
                        console.log('Sending button command:', value);
                        sendAction(value, false);
                    });
                    vm.formSchemas.forms.forEach(function (value) {
                        console.log('Sending form command:', value);
                        sendAction(value, true);
                    });
                }

                // Gestione macro per oggetti Greengrass
                if (vm.isGreengrassObject && vm.macroCommands && Object.keys(vm.macroCommands).length > 0) {
                    console.log('%c=== SENDING GREENGRASS MACRO COMMANDS ===', 'color: #E91E63; font-weight: bold;');

                    Object.keys(vm.macroCommands).forEach(function(macroAlias) {
                        var macroCommandsList = vm.macroCommands[macroAlias];

                        // Ordina i comandi per order
                        macroCommandsList.sort(function(a, b) {
                            return a.order - b.order;
                        });

                        console.log('Sending macro:', macroAlias, 'with', macroCommandsList.length, 'commands');

                        macroCommandsList.forEach(function(cmd) {
                            console.log('  Command:', cmd.actionCommand, 'Arguments:', cmd.arguments);
                            sendGreengrassMacroCommand(cmd);
                        });
                    });
                }

                // Gestione macro per oggetti non-Greengrass (logica originale)
                if (!vm.isGreengrassObject && vm.macro) {
                    vm.macro.forEach(function (value) {
                        value.macroActions.sort(function (a, b) {
                            var commandA = a.order, commandB = b.order;
                            return commandA - commandB;
                        });
                        for(var i = 0; i < value.macroActions.length; i++){
                            if(value.macroActions[i].arguments == "{}") {
                                sendMacro(value.macroActions[i], false);
                            } else {
                                sendMacro(value.macroActions[i], true);
                            }
                        }
                    });
                }

                vm.objectList.forEach(function (commandQueue) {
                    // Initialize tabActionsQueues for this object if it doesn't exist
                    if(!vm.tabActionsQueues[commandQueue.objectUniqueCode]) {
                        vm.tabActionsQueues[commandQueue.objectUniqueCode] = {commands: [], object: commandQueue};
                    }

                    console.log('%cQueue for object: ' + commandQueue.objectUniqueCode, 'color: #2196F3; font-weight: bold;');
                    console.log('Commands in queue:', vm.tabActionsQueues[commandQueue.objectUniqueCode].commands);

                    vm.tabActionsQueues[commandQueue.objectUniqueCode].scheduleDateTime = vm.scheduleDateTime;
                    vm.tabActionsQueues[commandQueue.objectUniqueCode].cron = vm.cron;
                    if(vm.cron === true && vm.repeatNumber && vm.repeatTime) {
                        vm.tabActionsQueues[commandQueue.objectUniqueCode].cronExpression = vm.repeatNumber  + " " + vm.repeatTime;
                    } else if(vm.cron === true && (!vm.repeatNumber || !vm.repeatTime)) {
                        AlertService.error("Fill Repetition fields");
                        return;
                    }

                    vm.commands = {};
                    vm.commands.commands = vm.tabActionsQueues[commandQueue.objectUniqueCode].commands;
                    vm.commands.object = commandQueue;

                    vm.commands.scheduleDateTime = vm.tabActionsQueues[commandQueue.objectUniqueCode].scheduleDateTime;
                    vm.commands.cronExpression = vm.tabActionsQueues[commandQueue.objectUniqueCode].cronExpression;

                    var d = new Date();
                    var dd = d.getDate();
                    var MM = d.getMonth();
                    MM++;
                    var yyyy = d.getFullYear();
                    vm.commands.alias = "Queue_"+commandQueue.objectUniqueCode+"_"+dd+"/"+MM+"/"+yyyy;

                    console.log('%cFinal commands object to send:', 'color: #4CAF50; font-weight: bold;');
                    console.log(vm.commands);

                    Queue.create(vm.commands, onSuccess, onError);
                });

            }
            function onSuccess() {
                //reset tab actions queues
                vm.tabActionsQueues = [];
                console.log('%cCommands sent successfully!', 'color: #4CAF50; font-weight: bold;');
            }

            function onError(error) {
                //reset tab actions queues
                vm.tabActionsQueues = [];
                console.error('%cError sending commands:', 'color: #F44336; font-weight: bold;', error);
                AlertService.error(error.data.message);
            }
        }

        vm.cleanEntity = function (entity, commandName, withArgs, isMacro) {
            if(!isMacro){
                if (withArgs) {
                    var args = {};
                    for (var key in entity.schema.properties) {
                        if(entity[key] instanceof Date) {
                            args[key] = String(entity[key].getHours()).padStart(2, '0') + ":" + String(entity[key].getMinutes()).padStart(2, '0');
                        } else {
                            args[key] = entity[key];
                        }
                    }
                }
                if(args == undefined){
                    args = {};
                }

                console.log('%cCleaning entity for command: ' + commandName, 'color: #9C27B0;');
                console.log('  Entity:', entity);
                console.log('  Action ID:', entity.actionId);
                console.log('  Device Release Map:', vm.actionDeviceReleaseMap[entity.actionId]);

                // Get deviceReleases from actionDeviceReleaseMap
                var deviceReleasesInfo = vm.actionDeviceReleaseMap[entity.actionId][0].deviceReleases;

                var cleanedEntity = {
                    id: entity.actionId,
                    actionCommand: commandName,
                    deviceReleases: deviceReleasesInfo,
                    arguments: args
                };

                console.log('  Cleaned entity:', cleanedEntity);

                return cleanedEntity;
            } else {
                return {
                    id: entity.tabActions.id,
                    arguments: entity.argumentMap,
                    actionCommand: entity.tabActions.actionCommand,
                    deviceReleases: entity.tabActions.deviceReleases,
                    argumentMap: entity.argumentMap
                };
            }
        };

        function sendAction(action, withArgument) {
            console.log('%cSendAction called', 'color: #FF9800;');
            console.log('  Action:', action);
            console.log('  With Argument:', withArgument);
            console.log('  Is Greengrass:', vm.isGreengrassObject);

            vm.objectList.forEach(function (commandObject) {
                console.log('  Processing object:', commandObject.objectUniqueCode);

                // For Greengrass objects, send to all objects regardless of deviceReleases match
                if (vm.isGreengrassObject) {
                    console.log('    Adding to queue (Greengrass)');
                    vm.addCommandInQueue(commandObject, action, withArgument, false);
                } else {
                    // Original logic for non-Greengrass objects
                    commandObject.deviceReleases.forEach(function (dr) {
                        console.log('    Checking device release:', dr.id, 'vs', action.deviceReleases.id);
                        if(dr.id == action.deviceReleases.id) {
                            console.log('    Match! Adding to queue');
                            vm.addCommandInQueue(commandObject, action, withArgument, false);
                        }
                    });
                }
            });
        }

        function sendMacro(action, withArgument) {
            vm.objectList.forEach(function (commandObject) {
                vm.addCommandInQueue(commandObject, action, withArgument, true);
            });
        }

        function sendGreengrassMacroCommand(command) {
            console.log('%cSendGreengrassMacroCommand called', 'color: #E91E63;');
            console.log('  Command:', command);

            vm.objectList.forEach(function (commandObject) {
                console.log('  Processing object:', commandObject.objectUniqueCode);

                if(!vm.tabActionsQueues[commandObject.objectUniqueCode]) {
                    vm.tabActionsQueues[commandObject.objectUniqueCode] = {commands: [], object: {}};
                    vm.tabActionsQueues[commandObject.objectUniqueCode].object = commandObject;
                }

                var cleanedCommand = {
                    id: command.actionId,
                    actionCommand: command.actionCommand,
                    deviceReleases: command.deviceReleases,
                    arguments: command.arguments || {}
                };

                console.log('  Adding macro command to queue:', cleanedCommand);
                vm.tabActionsQueues[commandObject.objectUniqueCode].commands.push(cleanedCommand);
            });
        }

        vm.addCommandInQueue = function(commandObject, action, withArgument, isMacro) {
            console.log('%cAddCommandInQueue called', 'color: #00BCD4;');
            console.log('  Object:', commandObject.objectUniqueCode);
            console.log('  Action:', action);
            console.log('  With Argument:', withArgument);
            console.log('  Is Macro:', isMacro);

            if(!vm.tabActionsQueues[commandObject.objectUniqueCode]) {
                vm.tabActionsQueues[commandObject.objectUniqueCode] = {commands: [], object: {}};
                vm.tabActionsQueues[commandObject.objectUniqueCode].object = commandObject;
            }
            if(isMacro) {
                vm.tabActionsQueues[commandObject.objectUniqueCode].commands.push(vm.cleanEntity(action, action.tabActions.actionCommand, withArgument, true));
            } else {
                var cleanedCommand = vm.cleanEntity(action, action.command, withArgument, false);
                console.log('  Cleaned command to add:', cleanedCommand);
                vm.tabActionsQueues[commandObject.objectUniqueCode].commands.push(cleanedCommand);
            }

            console.log('  Updated queue:', vm.tabActionsQueues[commandObject.objectUniqueCode].commands);
        }

        vm.openCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.scheduleDatetime) {
                vm.scheduleDatetime.isOpen = !vm.scheduleDatetime.isOpen;
            } else {
                vm.scheduleDatetime = {isOpen: true};
            }
        };

        vm.loadAll();
    }
})();
